import React from 'react';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';

interface IBSwitchProps {
  checked: boolean;
  disabled: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const IBSwitch: React.FC<IBSwitchProps> = ({
  checked,
  disabled,
  onCheckedChange,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id="ib-switch"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
      />
      <Label
        htmlFor="ib-switch"
        className="text-xs sm:text-sm text-muted-foreground font-medium cursor-pointer"
      >
        {checked ? 'Yes' : 'No'}
      </Label>
    </div>
  );
};

export default IBSwitch;
